export const resetPasswordSelector = (state) => ({
  resetPassword: state.resetPassword.result
});
